import React, { useState, useContext, useEffect, useCallback, useRef } from 'react';
import { ShopperContext } from '../context/shopper'

import HeadingBuilder from '../components/HeadingBuilder';
import Checkbox from '../components/Checkbox';
import OrderItem from '../components/OrderItem'
import OthersOrders from '../components/OthersOrders'
import GoShoppingRow from '../components/GoShoppingRow'
import TripCost from './TripCost'
import GoShopping from './GoShopping'

import { tax_multiplier, get_tax_type_from_char, formatMoney, getTimestringNow,
         doesArrayExist, findAbsAmtAsPct,
         showRoundedAbsAmt, absAmtAsPctEvenIfWeighty,
       } from '../utils';
import { usePricing } from "../hooks/useSkuUtils";
import { useStyles } from "../hooks/useStyles";
import { useUtils } from "../hooks/useUtils";
import { usePhrasing, useFormats } from "../hooks/useSkuUtils";
import * as Constants from '../constants';
    

import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";

// Present a list of orderItems that is, or can be, scheduled for this trip.
// Shopper can check a box to add a non-scheduled sku to their order list.
const ShoppingList = ({trip}) => {
  console.log("slB", trip)
  const { shopper, circleShoppers, skus, prices, orderItems, signedIn,
          showSlimShopList, handleSlimShopCheckboxChange,
          showOthersOrders, toggleShowOthersOrders, toggleShowOthersZeroOrders,
          handleInitSlimShopPref,
          showOthersZeroOrders,
          showOutlayWithTax, toggleShowOutlayWithTax,
          setShowShoppingListToFalse,
          tripDimSkus,
          tripCartSkus,
          tripSkuWeights,
        } = useContext(ShopperContext);
  console.log("slA", circleShoppers);
  console.log("slC", orderItems);
  console.log("slD", prices);
  console.log("slE", skus);
  const { t } = useTranslation();
  const { getPrice, getTswObject, getActualWeight } = usePricing();
  const { textAlignLeft, textAlignCenter } = useStyles();
  const { is_shopper_a_circle_admin,
          shoppers_order_for_this_sku_this_trip,
          s_by_updated_at,
        } = useUtils();

  //console.log("ttr slEa", trip.tax_rate);
  //console.log("ttr slEb", trip.tax_rate/100);
  //console.log("ttr slEc", null/100);  // this is 0? Surprising.
  console.log("ttrf slF", trip.tax_rate_food/100);

  const csvLink = useRef();
  const makeCsvRef = useRef(null);
  const shoppingListTableId = 'ShoppingListMainTable';

  const [downloadIsClicked, setDownloadIsClicked] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [showIdentifier, setShowIdentifier]     = useState(false);
  const [showShortname, setShowShortname]       = useState(false);
  const [showUnitCost, setShowUnitCost]         = useState(false);
  const [showTripCost, setShowTripCost]         = useState(false);
  const [showTripBoughtCost, setShowTripBoughtCost] = useState(false);
  const [showGoShopList, setShowGoShopList]     = useState(false);
  const [showOrderBreakout, setShowOrderBreakout] = useState(false);
  const [dataForDownload, setDataForDownload] = useState([]);
  const [downloadReady, setDownloadReady] = useState(false);

  const [showOiTableForSku, setShowOiTableForSku] = useState(() => {
    const obj = {};
  
    trip.sku_ids.forEach((skuId) => {
      obj[skuId] = false
    });

    return obj;
  });

  const {
    getNameColComment,
    shopListIdHeading,
    shopListBrandHeading,
    shopListNameLabelHeading,
    shopListStoreHeading,
    shopListWhoHeading,
    shopListUnitCountHeading,
    shopListPriceHeading,
    shopListUnitQtyHeading,
    shopListUnitCostHeading,
    shopListWantdHeading,
    shopListRangeNoteHeading,
    shopListOutlayHeading,
    shopListOColHeading,
    shopListCircleAmtHeading,
    shopListCircleMoneyHeading,
    shopListDetailsHeading,
    getUnitCountColHeaderTippyContent,
    getUnitCountColHeaderAudioTippyContent,
    getIdColTippyText,
  } = usePhrasing();

  const { getCatHeader } = useFormats();

  useEffect(() => {
    if (csvLink && csvLink.current && downloadReady) {
      csvLink.current.link.click();
      setDownloadReady(false);
    }
  }, [downloadReady]);

// Effect runs after render when 'downloadInProgress' changes to true via
// shopper requesting download.
useEffect(() => {
  if (downloadInProgress && makeCsvRef.current) {
    requestAnimationFrame(() => {
      makeCsvRef.current('DOWNLOAD');  // makeCsvFromTable('DOWNLOAD');
      setDownloadInProgress(false);
    });
    // Or could do:
    // setTimeout(() => {
    //   makeCsvRef.current('DOWNLOAD');
    //   setDownloadInProgress(false);
    // }, 0);
  }
}, [downloadInProgress]);

  // Assumes 'shopper' has been defined by the time of opening ShoppingList.
  useEffect(() => {
    handleInitSlimShopPref(shopper.prefer_slim_screen);
  }, [handleInitSlimShopPref, shopper]);

  //// see eslint warning re how tripCosts, tripCostsWithTax should be in 'useMemo'
  const tripCosts = {
    '~TOTAL': 0
  };

  const tripCostsWithTax = {
    '~TOTAL': 0
  };

  const sku_Price = {};
  // variable has '_' in its name to distinguish it from the prop
  // we pass to OthersOrders component

  const if_shopper_is_circle_admin = is_shopper_a_circle_admin({
    cShoppers: circleShoppers, circle_id: trip.circle.id, shopper_id: shopper.id
  });

  const curr_symbol = trip.circle.currency_symbol.replace(/[ _]$/, '');
  // Some curr_symbol values have a trailing char. Not needed for headers, so rm

  const tripSkus = trip.sku_ids.map( sku_id => skus.find(s =>  s.id === sku_id) )
  console.log("sl tripSkus", tripSkus);

  const get_tax_rate = ({ taxType, trip }) => {
    return Math.round(
        10_000 * (
          tax_multiplier({ tax_type: taxType, trip }) - 1
        )  // gives something like 10_000 * (1.0650000005 - 1) = 650.000005
      )    // which rounds to 650
  
    / 100  // so that returns 650/100 = 6.5
  }

  const skusDimmedForThisTrip =
    tripDimSkus.filter( (tds) =>  tds.trip_id === trip.id )

  const skusBoughtForThisTrip =
    tripCartSkus.filter( (tcs) =>  tcs.trip_id === trip.id )

  // was a given sku marked as bought for this trip?
  const isSkuBought = useCallback((sku_id) => {
    return skusBoughtForThisTrip.some( (tcs) =>  tcs.sku_id === sku_id )
  }, [skusBoughtForThisTrip]);

  function s_by_sku_cat_brand_label_identifier( a, b )
  {
    //console.log("sbsli", a)
    // sku.category is not supposed to be null, but we can still protect against
    if ( (a[1].category ?? 0) < (b[1].category ?? 0) ){
        // console.log('asi 1 ootts', a[1].id, a[1].category ?? 0)
      return -1;
    }
    if ( (a[1].category ?? 0) > (b[1].category ?? 0) ){
        // console.log('asi -1 ootts', a[1].id, a[1].category ?? 0)
      return 1;
    }

    if ( a[1].brand.toLowerCase() < b[1].brand.toLowerCase() ){
      return -1;
    }
    if ( a[1].brand.toLowerCase() > b[1].brand.toLowerCase() ){
      return 1;
    }

    if ( a[1].label.toLowerCase() < b[1].label.toLowerCase() ){
      return -1;
    }
    if ( a[1].label.toLowerCase() > b[1].label.toLowerCase() ){
      return 1;
    }

    if ( a[1].identifier < b[1].identifier){
      return -1;
    }
    if ( a[1].identifier > b[1].identifier){
      return 1;
    }

    return 0;
  }

  // Schwartzian transform allows sorting objects by an attribute which itself
  // might be complex/expensive to look up.
  // In this case, since an 'order' only has a 'sku_id' and not a whole sku
  // object, we can sort the orders by associating each one with a full sku
  // object as a tuple.
  // Next sort the array of tuples by an attribute of the full sku object.
  // Now that the tuples are sorted, extracting the 'order' part of each tuple
  // (tuple[0]) provides a sorted list of orders.
  //
  // Hmm, since we go to the trouble of finding the sku detail, it may prove
  // helpful to attach such detail to the order object!
  // Well, "no", complicated to do this - changing 'order' would change state?
  function schwartzSortOrders({orders, skusOfTrip}) {
    const tuples = orders.map(
      order => {
        console.log('sl 2954 sso order', order)
        return [ order, skusOfTrip.find(s =>  s.id === order.sku_id) ]
      }
    );
    // console.log('tuples orders', tuples);

    const sortedOrders = tuples.sort(s_by_sku_cat_brand_label_identifier)
                               .map(tuple => tuple[0]);
    return sortedOrders;
  }

  const findCostForShopper = ({o, price, sku}) => {
    const effectiveUnitCost = findAbsAmtAsPct({topNum: price, sku}) / 100;
    return Number(o.abs_amount) * effectiveUnitCost;
  }

  function getOrdersOfTrip() {
    // hold the shopper's abs_amt amounts by sku (for saving into state).
    const tmpShopAmtOfSku = {};

    // Accumulate the abs_amt amounts of the OTHER circleShoppers for each sku.
    const tmpCircAmtOfSku = {};

    // For each sku, build up a semicolon-delimited string of
    // "o.shopper_id,o.abs_amount" pairs, where o.abs_amount > 0
    const tmpOthersAmtOfSku = {};

    // Filter available orderItems by whether an order_item matches this trip.
    const tripOrders = trip.trip_order_items.filter(order => {
      const o = {...order};
      console.log("oott 2954 order t.toi", o);
      const skuIdOfOrder = o.sku_id.toString();
      console.log("siooA", skuIdOfOrder);
      console.log("siooB", o.shopper_id);
      console.log("siooC", shopper.id);
      console.log("siooE", o.sku_id);

      const orderCircleShopper =
        circleShoppers.find(cs => cs.shopper_id == o.shopper_id);

      const orderShopperIdentifier = orderCircleShopper.shopper.identifier;

      const sku = tripSkus.find(s =>  s.id == o.sku_id);
      console.log('oott sku', sku);

      tmpShopAmtOfSku[skuIdOfOrder] ||= 0;
      console.log("oott init sku for shopper", tmpShopAmtOfSku);
      tmpCircAmtOfSku[skuIdOfOrder] ||= 0;
      console.log("oott init sku for non-shopper", tmpCircAmtOfSku);
      tmpOthersAmtOfSku[skuIdOfOrder] ||= '';

      if (o.shopper_id == shopper.id) {
        // discussion here: https://stackoverflow.com/questions/29280445/reactjs-setstate-with-a-dynamic-key-name
        // including this: https://stackoverflow.com/a/58733173 but: do we
        // need to use "this" here?
        // this.setState({ [`image${i}`]: image })
        // And/or: https://dev.to/andyrewlee/cheat-sheet-for-updating-objects-and-arrays-in-react-state-48np
        // setTodos({...todos, [todo.id]: todo});

        // shopper will have only one order for a particular sku for a trip. So,
        // we can assign the single abs_amount we'll find for that sku to tmp-object.
        // Given that existing circle shoppers are supposed to get orderItems with
        // abs_amount of zero when another shopper adds sku to the trip list, then
        // there should be one order for the shopper for each active sku in the trip.
        // This means there will be a "header" record in the ShoppingList for each sku,
        // even if the amount is zero for the shopper, to provide context for any following
        // "Show All Shoppers" orders that show quantities ordered by other
        // CircleShoppers.
        // 231204: I think the following has been handled:
        // This breaks down for that brief period where a shopper has just been added
        // to the circle, but after some orders have been placed. This is a minor
        // issue we can handle later.
        tmpShopAmtOfSku[skuIdOfOrder] = Number(o.abs_amount);
        console.log("oott is shopper, abs_amt", Number(o.abs_amount), tmpShopAmtOfSku);

        console.log("oott sku 3453", sku);
        sku_Price[sku.id] ||= getPrice({sku_id: sku.id, trip, prices});

        console.log("oott osi", orderShopperIdentifier);
        tripCosts[orderShopperIdentifier] ||= 0;

        // If we should only include cost for skus marked as bought, i.e. in
        // the shopping basket, and there is no record showing sku as bought,
        // then show a cost of $0.00
        const needBoughtButWasntBought = 
          showTripBoughtCost  &&  ! isSkuBought(sku.id);

        const costForShopper =
          needBoughtButWasntBought
          ? 0
          :
          findCostForShopper({o, sku, price: sku_Price[sku.id]});
        // console.log('oott sku costForShopper', sku, costForShopper)

        tripCosts[orderShopperIdentifier] += costForShopper;
        tripCosts['~TOTAL']               += costForShopper;

        const effectiveUnitCostWithTax =
          needBoughtButWasntBought
          ? 0
          : findAbsAmtAsPct({
          topNum: 
            sku_Price[sku.id]
            * tax_multiplier({
                tax_type: (sku.tax_type || 0), // tax_type of 0 indicates 'No Tax'
                trip,
              })
          ,sku
        }) / 100;

        const skuCostWithTaxForShopper =
          Number(o.abs_amount) * effectiveUnitCostWithTax;

        tripCostsWithTax[orderShopperIdentifier] ||= 0;
        tripCostsWithTax[orderShopperIdentifier] += skuCostWithTaxForShopper;
        tripCostsWithTax['~TOTAL']               += skuCostWithTaxForShopper;

        return true;  // tells filter to keep this orderItem
      } else {
        tmpCircAmtOfSku[skuIdOfOrder] += Number(o.abs_amount);
        console.log("oott is not shopper, abs_amt", Number(o.abs_amount), tmpCircAmtOfSku);

        if (Number(o.abs_amount) >= 0) {
          tmpOthersAmtOfSku[skuIdOfOrder] += o.shopper_id + ',' + Number(o.abs_amount) + ';';
        }

        // The main shopper should have loaded a price value for the sku
        // since everyone is supposed to have a amt-0 entry for any sku
        // that another shopper has added to the circle's shopping list.
        // But we'll check anyway...
        sku_Price[sku.id] ||= getPrice({sku_id: sku.id, trip, prices});

        // see comment above re assignment like this one:
        const needBoughtButWasntBought = 
          showTripBoughtCost  &&  ! isSkuBought(sku.id);

        const costForOtherShopper =
          needBoughtButWasntBought
          ? 0
          :
          findCostForShopper({o, sku, price: sku_Price[sku.id]});
        // console.log('oott sku costForOtherShopper', sku, costForOtherShopper)

        tripCosts[orderShopperIdentifier] ||= 0;
        tripCosts[orderShopperIdentifier] += costForOtherShopper;
        tripCosts['~TOTAL']               += costForOtherShopper;

        const skuCostWithTaxForShopper =
          needBoughtButWasntBought
          ? 0
          :
          Number(o.abs_amount)
            * sku_Price[sku.id]
            * tax_multiplier({
                tax_type: (sku.tax_type || 0), // tax_type of 0 indicates 'No Tax'
                trip,
              })
            / (sku.type === 'MultipackItem' ? sku.unit_count : 1);

        tripCostsWithTax[orderShopperIdentifier] ||= 0;
        tripCostsWithTax[orderShopperIdentifier] += skuCostWithTaxForShopper;
        tripCostsWithTax['~TOTAL']               += skuCostWithTaxForShopper;

        return false;  // tells filter: ignore orderItem, it's not shopper's
      }

    });
    console.log('sl sku_Price', sku_Price);
    console.log('sl tripCosts', tripCosts);
    console.log('sl tripCostsWithTax', tripCostsWithTax);

    console.log("tsqos 1", tmpShopAmtOfSku);
    console.log("toqos 1", tmpOthersAmtOfSku);
    console.log("tripOrders", tripOrders);
    const ordersOfTheTrip = schwartzSortOrders({
      orders:     tripOrders,
      skusOfTrip: tripSkus
    });
    console.log("ordersOfTheTrip", ordersOfTheTrip);

    return {
      ordersOfTheTrip,
      tmpShopAmtOfSku,
      tmpCircAmtOfSku,
      tmpOthersAmtOfSku
    };
  }

  const {ordersOfTheTrip, tmpShopAmtOfSku, tmpCircAmtOfSku, tmpOthersAmtOfSku} =
    getOrdersOfTrip();

  return React.useMemo(() => {
    if (signedIn) {
      console.log('TripsOrdersQ', ordersOfTheTrip);
      console.log('TO shopAmtOfSku', tmpShopAmtOfSku);
      console.log('TO circAmtOfSku', tmpCircAmtOfSku);
      console.log('TO othersAmtOfSku', tmpOthersAmtOfSku);

      const handleIdClick = event => {
        // Clicking the 'ID' column header toggles showing of sku identifiers.
        // But, a 'downloadCsv' may be in progress, and failure to show full
        // identifiers displays an appropriate warning.
        // The shopper can disappear the warning by clicking the warning icon.
        // This sets 'downloadIsClicked' to 'false' and unsets the warning icon's
        // default setting of wanting to display, so we're back where we started.
        // The shopper could also click the 'ID' column header to expand the sku
        // identifiers. This stops showing the warning (whose default state is to
        // show) because {downloadIsClicked  &&  ! showIdentifier} is no longer
        // 'true'. (Identifiers are showing.) But the 'downloadIsClicked' value
        // of 'true' is still lurking, ready to fire up the warning if the
        // shopper decides to click 'ID', i.e. toggle back to '!showIdentifier'.
        // No. Once the warning goes away via clicking the warning icon or by
        // showing full values for sku identifiers, it should not reappear due to
        // 'downloadIsClicked'. So, let's "initialize" 'downloadIsClicked' to be
        // 'false' any time we click 'ID'. If we click 'ID' with no download in
        // progress, setting it to 'false' will only reset 'false' to 'false'.
        // If it's in progress with a warning showing, IDs must not be showing.
        // Clicking the 'downloadCsv' button does nothing since it's already
        // showing the warning about needing to show identifiers. (A no-op.)
        // But, if the shopper clicks 'ID' to show IDs, we can reset
        // 'downloadIsClicked' to 'false' in preparation for a new round of
        // 'downloadIsClicked'. 
        setDownloadIsClicked(false)

        // Now do the toggle.
        setShowIdentifier(current => !current);
      };

      const handleUcClick = event => {
        setShowUnitCost(current => !current);
      };

      const handleGoShopClick = event => {
        setShowGoShopList(current => !current);
      };

      const handleOrderBreakoutClick = event => {
        setShowOrderBreakout(current => !current);
      };

      const handleTcClick = event => {
        setShowTripCost(current => !current);
      };

      const handleTbcClick = event => {
        setShowTripBoughtCost(current => !current);
      };

      const handleOiClick = (skuId, event) => {
        const current = showOiTableForSku[skuId]
    
        setShowOiTableForSku(prev => ({
          ...prev,
          [skuId]: !current
        }));
      };

      const orderHeadings = {
    identifier:   shopListIdHeading({
                    buttonActionId: handleIdClick,
                    tippyAlertTextId: getIdColTippyText()
    // Click 'ID' button to toggle showing identifier values below.
        
    // Each item should have an ID. Maybe it's a barcode, or sometimes stores
    // assign their own ID or code for the Sku. You can invent your own ID for
    // the Sku and change it later.
                  }),
    identifierV:  shopListIdHeading({
                    buttonActionId: null,
                    tippyAlertTextId: t('ordersList.id_col.tippyContent')
    // Each item should have an ID. Maybe it's a barcode, or sometimes stores
    // assign their own ID or code for the Sku. You can invent your own ID for
    // the Sku and change it later.
                  }),
    brand:        shopListBrandHeading(),
    label:        shopListNameLabelHeading({
                    tippyAlertTextNameLabel: getNameColComment({})
                  }),
    storeLabel:   shopListStoreHeading(),
    shortname:    shopListWhoHeading(),
    unitCount:    shopListUnitCountHeading({
        tippyAlertTextUc:  getUnitCountColHeaderTippyContent({ shopper }),
        tippyAlertAudioUc: getUnitCountColHeaderAudioTippyContent({ shopper }),
                  }),
    price:        shopListPriceHeading(),
    unitQty:      shopListUnitQtyHeading({}),
    unitCost:     shopListUnitCostHeading({
                    buttonActionUnitCost: handleUcClick,
                  }),
    wantd:        shopListWantdHeading({}),
    rangeNote:    shopListRangeNoteHeading({}),
    outlay:       shopListOutlayHeading({
                    buttonActionOutlay: toggleShowOutlayWithTax,
                    showOutlayWithTax: showOutlayWithTax
                  }),
    o:            shopListOColHeading({}),
    circleAmt:    shopListCircleAmtHeading(),
    detailsLink:  shopListDetailsHeading(),
    circleMoney:  shopListCircleMoneyHeading({
                    currencySymbolCircleMoney: curr_symbol,
                  }),
        }

      const numCategories = Constants.LAST_SKU_CATEGORY_INDEX + 1;
      // per the categories named in lookup_category()

      const catSeenOrders = Array(numCategories).fill( 0 );

      const ordersList =
        doesArrayExist(ordersOfTheTrip)
          ? ordersOfTheTrip.map((o) => {
              console.log('ol oott o', o);
              console.log('ol oott o.id', o.id);
              const sku = tripSkus.find(s => s.id == o.sku_id);
              console.log('olist sku', sku);

              const tsw = getTswObject({ sku, trip, tripSkuWeights });

              const thePrice = getPrice({sku_id: sku.id, trip, prices});
              const inCartStatus =
                downloadInProgress
                  ? (isSkuBought(sku.id) ? 1 : 0)
                  : null

              const catHeader = getCatHeader({
                o, sku,
                k: 'oott',
                catSeen: catSeenOrders,
              })

              const actualWeight =
                sku.type === 'WeightyItem'
                  ? getActualWeight({sku, trip, tripSkuWeights})
                  : undefined;

  // skuAmtForOthers looks like: 6,0;10,0;5,0;17,0;19,0; (shopperId, absAmt;...)
  // unpack/split by ';' and then by ','
              const shopperDelim = ';';
              const amtDelim = ',';

              const skuAmtForOthers =
                                    tmpOthersAmtOfSku[o.sku_id.toString()] || ''
              const others = skuAmtForOthers.split(shopperDelim);
              // (split here by ';' and then later by ',')

  // Generate an array of objects that each holds data about another
  // CircleShopper's interest about that sku.
  // The objects are ordered from oldest shopper orderItem to most recent.
              const othersData =
  // remove empty elements ('') that result from ';' at end of skuAmtForOthers
  // or if skuAmtForOthers was empty
  // or if skuAmtForOthers was 0
  //   (unless this is for an admin who wants to see items of abs_amt of 0)
                others.filter( oth =>
                  oth !== ''
                    && (
                      oth.slice(-2) != ',0'
                        ||
                      (showOthersZeroOrders && if_shopper_is_circle_admin)
                      // admin check is superfluous
                    )
                )
            
                .map((oth) => {
                  const [othOrderShopperId, othOrderAmt] = oth.split(amtDelim);
                  // (split above by ';' and then here by ',')
            
                  const othShopperOrderItem =
                    shoppers_order_for_this_sku_this_trip({
                      oItems: orderItems,
                      shopper_id: othOrderShopperId,
                      sku_id: sku.id,
                      trip_id: o.trip_id
                    })
                    // console.log("ooNa orderItem", othShopperOrderItem);

      // NOTE: I'm guessing othShopperOrderItem.abs_amount == othOrderAmt
      // which brings into question: why even build skuAmtForOthers
      // with its delims and split requirements?
      // Just search for "other" shoppers in the circle and the
      // abs_amount of their orders for same sku and trip.
                  return [ othShopperOrderItem, othOrderAmt ];
                })
                .sort(s_by_updated_at)
                .map((othOIandAmt) => {
                  const [ othShopperOrderItem, othOrderAmt ] = othOIandAmt;
                  // console.log("ooNb orderItem", sku.id, othShopperOrderItem);
                  const othAbsAmt = othOrderAmt;
                  // console.log("ooNc othAbsAmt", sku.id, othAbsAmt);
                  const othAbsAmtAsPct = Math.trunc(
                                findAbsAmtAsPct({topNum: othAbsAmt, sku}) );
                  // console.log("ooJ othAbsAmtAsPct", sku.id, othAbsAmtAsPct);
                  // console.log("ooJb order o", o);

                  const unitQty =
                    (sku.type === 'MultipackItem' || sku.type === 'WeightyItem')
                      ? Math.round(othAbsAmt * 100) / 100
                      : '--';
                  // console.log("ooK unitQty", sku.id, unitQty);
            
                  const adjustedAbsAmtAsPct =
                    absAmtAsPctEvenIfWeighty({
                      sku, actualWeight, absAmtAsPct: othAbsAmtAsPct 
                    });
      
                  return ({
                    othShopperOrderItem: othShopperOrderItem,
                    othAbsAmt:           othAbsAmt,
                    unitQty:             unitQty,
                    adjustedAbsAmtAsPct: adjustedAbsAmtAsPct,
                  })
                })
              // console.log('sl od', sku.label, othersData);
              
              const oi = <OrderItem
                        key={'oiCompo' + o.id}
                        order={o} 
                        trip={trip} 
                        sku={sku} 
                        tsw={tsw} 
                        inCartStatus={inCartStatus}
                        actualWeight={actualWeight}
                        othData ={ othersData }
                        headings={orderHeadings}
                        skuAmtForShopper={ tmpShopAmtOfSku[sku.id.toString()] }
                        skuAmtForCircle ={ tmpCircAmtOfSku[sku.id.toString()] }
                        showIdentifier ={ showIdentifier }
                        showShortname ={ showShortname }
                        showUnitCost ={ showUnitCost }
                        if_shopper_is_circle_admin ={if_shopper_is_circle_admin}
                        skuPrice ={ thePrice }
                        showOiTable = {showOiTableForSku[sku.id]}
                        handleOiClick = {(event) => handleOiClick(sku.id, event)}
                    />

              const moreStuff =
                (showOthersOrders && !showOiTableForSku[sku.id])
                  ? <OthersOrders
                      key={ 'ooCompo' + o.id }
                      if_shopper_is_circle_admin ={ if_shopper_is_circle_admin }
                      order ={ o }
                      trip={ trip } 
                      sku ={ sku }
                      skuPrice ={ thePrice }
                      actualWeight ={ actualWeight }
                      inCartStatus ={ inCartStatus }
                      othData ={ othersData }
                    />
                  : null;
              // console.log('sl ms', moreStuff);

              return [catHeader, oi, moreStuff];
            })
          : null;
      console.log('ShoppingList.js ordersListQ: ', ordersList);

      const tripShoppers = trip.trip_shoppers;
      console.log('ShoppingList.js tripShoppers: ', tripShoppers);

      const tripOrderItems = trip.trip_order_items;
      console.log('ShoppingList.js tripOrderItems: ', tripOrderItems);

      const addRemoveItemComment =
        t('ordersList.button_text.tippyContentAddItem',
          {removeItem:
            if_shopper_is_circle_admin
              ? t('ordersList.button_text.tippyContentRemoveItem')
              : null
          }
        )

      const showOthersOrdersTippyText =
        showOthersOrders
          ? t('ordersList.showHideOthersOrders.tippyContentWhenShow')
          : t('ordersList.showHideOthersOrders.tippyContentWhenHide')

      const catSeen = Array(numCategories).fill( 0 );
      // console.log('ShoppingList.js catSeen: ', catSeen);

      const goShopList =
        doesArrayExist(ordersOfTheTrip)
          ? ordersOfTheTrip.map(o => {
              console.log('ootts goShopList order', o);

              const sku = tripSkus.find(s => s.id == o.sku_id);
              console.log('ootts olist sku', sku);
              const tsw = getTswObject({ sku, trip, tripSkuWeights });

              const thePrice = getPrice({sku_id: sku.id, trip, prices});

              // console.log('tds start', tripDimSkus, trip.id, sku.id);
              const tripDimSkuObj =
                skusDimmedForThisTrip.find(tds =>  tds.sku_id === sku.id);
              // value is either 'undefined' or a 'tripDimSkus' object
              // console.log('tds tdso', tripDimSkuObj);

              // console.log('tcs start', tripCartSkus, trip.id, sku.id);
              const tripCartSkuObj =
                skusBoughtForThisTrip.find(tcs =>  tcs.sku_id === sku.id);
              // value is either 'undefined' or a 'tripCartSkus' object

              // if we have amt > 0 then make a GoShoppingRow for this sku
              if ( tmpShopAmtOfSku[sku.id.toString()]
                 + tmpCircAmtOfSku[sku.id.toString()]
                    > 0 ) {

                const catHeader = getCatHeader({
                  sku, o, catSeen, k: 'gsl'
                })

                // 0.81 - Kirkland, Butter, Salted, info, $14.68 ea, has 4
                const sl = <GoShoppingRow
                  key              = { sku.id }
                  trip             = { trip } 
                  tripDimSkuObj    = { tripDimSkuObj } 
                  tripCartSkuObj   = { tripCartSkuObj } 
                  tsw              = { tsw } 
                  sku              = { sku } 
                  skuPrice         = { thePrice }
                  skuAmtForShopper = { tmpShopAmtOfSku[sku.id.toString()] }
                  skuAmtForCircle  = { tmpCircAmtOfSku[sku.id.toString()] }
                  showOrderBreakout= { showOrderBreakout }
                  tripShoppers     = { tripShoppers } 
                  tripOrderItems   = { tripOrderItems } 
                />

                return [catHeader, sl];
              } else {

              // Nobody wants any, so put 'null' vals - "flat" will skip past
                return [null, null, null];
              }
            })
          : null;
      console.log('ShoppingList.js goShopListQ: ', goShopList);

      const downloadCsvFromTable =
        (actionType, showIdentifier, setDownloadIsClicked) => {

        if (!showIdentifier) {
          setDownloadIsClicked(true);
        } else {
          setShowShortname(true);
          setDownloadInProgress(true);
        }
      }

      const makeCsvFromTable = (actionType) => {
        if (actionType === 'DOWNLOAD') {
          const extractData = (tableId, mapper) => {
            const myTab = document.getElementById(tableId);
            // console.log("Table guts: ", myTab);
            const rowObj = {};
            rowObj.id = {};
            rowObj.id.identifier = '';

            if (myTab) {
              const data = [...myTab.rows].map(
                (r) => [...r.cells].map(
                  (c, index) => {
    // Is the cell an input field? i.e. does it look like:
    // <td><span><input name="absAmtAsPct" type="text" value="0" inputmode="numeric" style="width: 60px;">%</span></td> 
                    const input = c.querySelector('input');
                    if (input) {
                      return input.value;
                    }

                    const textVal = c.textContent.trim();
                    // console.log("tVal", '"'+textVal+'"');

    // TODO: Could define some regex variables to DRY out some repeated use of such patterns, e.g. for removing '%' and '$' chars.
    // TODO: Should the processing of index 0-13 be stored elsewhere? Done differently?

                    if (index === 0) {  // Identifier / Lookup ID
    // If the identifier doesn't match the identifier in the previous row, reinitialize the rowObj.id object to prepare to receive new values for the columns.
                      if ( rowObj.id.identifier != textVal ) {
                        rowObj.id = {};
                        rowObj.id.identifier = textVal;
                      }

                      return rowObj.id.identifier;
                    }

    // If this 'brand' cell has text, this must be the first row for this identifier. ('brand' cells should be blank for the rows for other shoppers' orders for this sku.) This cell's text should be made available to any following rows that lack such text for this identifier, so stash it in 'rowObj.id.brand'.
    // This pattern is true for almost every column of text - this is the only notice.
                    if (index === 1) {
                      if ( /\w/.exec(textVal) ) {
                        rowObj.id.brand = textVal;
                      }
                      return rowObj.id.brand || textVal;  // 'textVal' in case '/\w/' failed.
                    }

                    if (index === 2) {
                      if ( /\w/.exec(textVal) ) {
                        rowObj.id.name = textVal;
                      }
                      return rowObj.id.name || textVal;
                    }

                    if (index === 3) {
                      if ( /\w/.exec(textVal) ) {
                        rowObj.id.store = textVal;
                      }
                      return rowObj.id.store || textVal;
                    }

                    // Shopper's shortname
                    if (index === 4) {
                      return textVal
                    }

                    if (index === 5) {
                      if ( /[\w-]/.exec(textVal) ) {
                        rowObj.id.unit_count = textVal;
                      }
                      return rowObj.id.unit_count || textVal;
                    }

    // In CSV, let's not pollute numeric vals with '$' and '%' chars:
                    if (index === 6) {
                      if ( /\w/.exec(textVal) ) {
                        rowObj.id.price =
                          textVal.replace(/^[^0-9]+/, '') // initial non-digits
                                 .replace(/[/].*$/, '');  // rm "/lb"
                      }
                      return rowObj.id.price || textVal;
                    }

                    if (index === 7) {  // Unit Qty
                      return textVal;
                    }

                    if (index === 8) {
                      if ( /[\w.]/.exec(textVal) ) {
                        rowObj.id.unit_price = textVal;
                      }
                      return rowObj.id.unit_price || textVal;
                    }

                    if (index === 9) {  // %Wantd
                      return textVal.replace(/[%]$/, '');
                    }

                    if (index === 10) {  //  #-# (range note)
                      return textVal;
                    }

    // If shopper activates "Outlay w/ Tax" (instead of plain "Outlay"), there will be extra text to indicate tax type (F, R, N). We need to remove that from Outlay values, but transforming the 'O' character into its tax rate (%) will go nicely in the 'O' column, so stash this away.
    // i.e. stash the tax rate in 'rowObj.id.X' and report later (via index 11.)
                    if (index === 11) {  // Outlay -or- Outlay w/ Tax
                      const regexpTaxType = / (.)\s*$/;
                      // i.e. at the end of input, look for a space char, then
                      // any char (save the char to Register 1 per parens), and
                      // zero or more space characters.
                      const match = textVal.match(regexpTaxType);
                      if (match && match[1]) {
                        const taxDecimal =
                          tax_multiplier({  // convert N/R/F to 0/1/2, then get tax_rate from that
                            tax_type: get_tax_type_from_char({ char: match[1] }),
                            trip
                          }) - 1;

                        rowObj.id.X = formatMoney({
                          suppress_symbol: true,  // is this really working?
                          currency_subunit: trip.circle.currency_subunit,
                          amount: taxDecimal * 100
                        });
                      }

                      // clean up the outlay text and return it for download.
                      return textVal.replace(/^[^0-9]+/, '') // initial nonNums
                                    .replace(regexpTaxType, '');
                    }

                    if (index === 12) {
                      return rowObj.id.X || t('ordersList.o_col.label');
    // For now it's good to show the effective tax rate here for "w/ tax".
                    }

                    if (index === 13) {
                      if ( /\w/.exec(textVal) ) {
                        rowObj.id.circleAmt = textVal.replace(/[%]$/, '');
                      }
                      return rowObj.id.circleAmt || textVal;
                    }

                    if (index === 14) {
                      if ( /\w/.exec(textVal) ) {
                        rowObj.id.circleOutlay = textVal.replace(/^[^0-9]+/, '')
                        // initial nonNums
                      }
                      return rowObj.id.circleOutlay || textVal;
                    }

                    // This column is artificial. Yes, the main table has this
                    // column but it populates it with 'null' values. This way
                    // it takes no horizontal space, but in so doing,
                    // it positions cells for this download phase when we
                    // can populate them when 'downloadInProgress' is true.
                    if (index === 15) {
                      return textVal;
                    }

                    return textVal;
                  }
                )
              );

      const csvHeaders = [
          t('ordersList.id_col.label'),                   // "ID",
          t('ordersList.brand_col.label'),                // "Brand",
          t('sku.label.label'),                           // "Name/Label",
          t('ordersList.store_col.label'),                // "Store",
          t('ordersList.info_col.csvLabel'),              // "Shopper",
          t('ordersList.unit_count_col.label'),           // "Unit Count",
     [ `${t('ordersList.price_col.label')} (${curr_symbol})` ], // "Price ($)",
          t('ordersList.unit_qty_col.label'),             // "Unit Qty",
          t('ordersList.unit_cost_col.label'),            // "Unit Cost",
          t('ordersList.abs_amt_col.label'),              // "%Wantd",
          t('ordersList.range_note_col.label'),           // "#-#",

 showOutlayWithTax
   ? [ `${t('ordersList.outlay_col.label_w_tax')} (${curr_symbol})` ] // "Outlay w/Tax ($)"
   : [ `${t('ordersList.outlay_col.label')} (${curr_symbol})` ], // "Outlay ($)"

 showOutlayWithTax
   ? [ `${t('ordersList.o_col.csvLabel')} (%)` ]          // "Tax (%)" 
   :      t('ordersList.o_col.csvLabel'),                 //  "O",

     [ `${t('ordersList.circle_amt_col.label')} (%)` ],   // "Circle Amt (%)",

          t('ordersList.circle_price_col.label', {        // "Circle $",
            currency_symbol: curr_symbol
          }),

          t('ordersList.o_col.boughtLabel'),              // "Bought",

      ];

              data[0] = csvHeaders;
              console.log("data0: ", data);

              //return data.map(mapper);
              return data;
            }
          };
        
          const newDataForDownload = extractData(shoppingListTableId, (x) => ({
            // e.g.
            // name: x[0],
            // address: x[1],
            // city: x[2],
            // state: x[3],
          }));
          //console.log("dataB: ", newDataForDownload);

          setDataForDownload(newDataForDownload);
          setDownloadReady(true);
        }
        setShowShortname(false);
      }
        makeCsvRef.current = makeCsvFromTable;


        const regex = /[ ']/g;
        const circleName = trip.circle.identifier.replace(regex, '_');

        return (
          <article>
              <h3 id="YourShoppingListH">
                {/* Trip's Shopping List */}
                {t('ordersList.formPart.headlineLabel')}
              </h3>

              { trip.circle.is_current
          ? <>
              <HeadingBuilder
                Size           = 'h5'
                headingText    = {t('ordersList.button_text.addItemToShoppingList')}
                // Put a Sku on the Shopping List
                buttonAction   = {setShowShoppingListToFalse}
                goButtonText   = {Constants.GET_ICON_RT_ARROW}
                tippyText      = {Constants.DOT}
                tippyAlertText = {addRemoveItemComment}
                // Click HERE to put a Sku from your Maybe-List onto the Shopping List...
              />
              <br/>
            </>
          : null
              }

              { ordersList && (
              showTripCost
                ? <TripCost
                    trip = {trip}
                    showTripCost = {showTripCost}
                    handleTcClick = {handleTcClick}
                    showTripBoughtCost = {showTripBoughtCost}
                    handleTbcClick = {handleTbcClick}
                    tripCosts = {tripCosts}
                    tripCostsWithTax = {tripCostsWithTax}
                  />
                : <Checkbox
                    size         = 'h6'
                    isChecked    = {showTripCost}
                    setIsChecked = {handleTcClick}
                    label        = {t('ordersList.button_text.showTripCost')}
                    // Show Trip Cost
                    tippyAlert   = {t('trip.tripCost.ckBoxToShowTippyContent')}
                  />
              )}
              { ordersList && (
              showGoShopList
                ? <>
                  <GoShopping
                    trip = {trip}
                    handleGoShopClick = {handleGoShopClick}
                    goShopList = {goShopList}
                    showOrderBreakout = {showOrderBreakout}
                    handleOrderBreakoutClick = {handleOrderBreakoutClick}
                  />
                  <br/>
                  </>
                : <Checkbox
                    size         = 'h6'
                    isChecked    = {showGoShopList}
                    setIsChecked = {handleGoShopClick}
                    label        = {t('trip.goShopping.showGoShopList')}
                    // Show 'Go Shopping' List
                    tippyAlert   = {t('trip.goShopping.showListButtonTippyContent')}
                    // Click this checkbox to view a list of what everyone wants.
                  />
              )}

              { ordersList && 
                <Checkbox
                  label        = {t('ordersList.showHideOthersOrders.labelShow')}
                  // Show Others' Orders
                  size         = 'h6'
                  isChecked    = {showOthersOrders}
                  setIsChecked = {toggleShowOthersOrders}
                  tippyAlert   = {showOthersOrdersTippyText}
                  // Click the checkbox to show everyone's Orders...
                  // Uncheck the checkbox to hide everyone else's Orders...
                />
              }

              { ordersList && if_shopper_is_circle_admin && showOthersOrders &&
                <Checkbox
                  label    = {t('ordersList.showHideOthersZeroOrders.labelShow')}
                  // Show Others' Zero Orders
                  isChecked    = {showOthersZeroOrders}
                  setIsChecked = {toggleShowOthersZeroOrders}
             tippyAlert = {t('ordersList.showHideOthersZeroOrders.tippyContent')}
// Click to toggle showing the complete list of Orders for each Sku of the Trip..
                />
              }

              { ordersList && 
                <Checkbox
                  label        = {t('ordersList.showSlimShopList.labelShow')}
                  // 'Show Slim Shopping List'
                  size         = 'h6'
                  isChecked    = {showSlimShopList}
                  setIsChecked = {()=> handleSlimShopCheckboxChange(shopper.id)}
                  tippyAlert   = {t('ordersList.showSlimShopList.tippyContent')}
                  // 'Click checkbox to show fewer columns'
                />
              }

              { ordersList && showOutlayWithTax && <>
                <br/>
                {t('ordersList.pageText.regSalesTax')}
                  {/* RegSalesTax: */}
                  {<>{get_tax_rate({ taxType: 1, trip })}%, </>}
                {t('ordersList.pageText.foodSalesTax')}
                  {/* FoodSalesTax:  */}
                  {<>{get_tax_rate({ taxType: 2, trip })}% </>}
              </>}

              { ordersList
                  ?<>
              <br/>
            { !showSlimShopList
            ? <HeadingBuilder
                buttonAction =  {(e) => downloadCsvFromTable('DOWNLOAD',
                                                        showIdentifier,
                                                        setDownloadIsClicked)}
                headingText = {t('ordersList.button_text.downloadReport')}
                // Download details to File

                tippyAlertText =
                  {t('ordersList.button_text.tippyContentDownloadReport',
                    {bought: t('ordersList.o_col.boughtLabel')}
                  )}
                tippyText      = {Constants.DOT}
                tippyInfoText  = {t('ordersList.button_text.infoDebugText')}

                forceShowBWarning = {downloadIsClicked  &&  ! showIdentifier}
                setShowBWarning   = {setDownloadIsClicked}
                bWarningMsg       = {t('ordersList.button_text.expandIdColDownloadWarning')}
                // Click column header "ID" to include Sku ID values...
              />
            : null
            }
              <CSVLink
                data={dataForDownload}
                filename={'swa'
                  + '_' + circleName + trip.circle.postal_code
                  + '_trip'
                  + '_' + trip.day
                  + '-' + trip.hour
                  + '__' + getTimestringNow().substring(2)
                  + '.csv'}
                  // swa_bloo99999_trip_2022-09-06-1459__230228172423.csv
                className='hidden'
                ref={csvLink}
                target='_blank'
              />
              <br/>

                    <Table id={shoppingListTableId}
                           style={textAlignLeft}
                           striped bordered hover
                           size="sm" >
                    <thead>
                      <tr>
                      {showSlimShopList
                      ? null
                      : <>
                        <th>
                          {orderHeadings.identifier}
                        </th>
                        <th>
                          {orderHeadings.brand}
                        </th>
                      </>
                      }
                        <th>
                          {orderHeadings.label}
                        </th>

                      {showSlimShopList
                      ? null
                      :
                        <th>
                          {orderHeadings.storeLabel}
                        </th>
                      }

                      {showOthersOrders || showShortname
                      ?
                        <th>
                          {orderHeadings.shortname}
                        </th>
                      : null
                      }

                      {showSlimShopList
                      ? null
                      :
                        <th>
                          {orderHeadings.unitCount}
                        </th>
                      }
                        <th style={textAlignCenter}>
                          {orderHeadings.price}
                        </th>
                      {showSlimShopList
                      ? null
                      : <>
                        <th>
                          {orderHeadings.unitQty}
                        </th>
                        <th>
                          {orderHeadings.unitCost}
                        </th>
                      </>
                      }
                        <th>
                          {orderHeadings.wantd}
                        </th>
                      {showSlimShopList
                      ? null
                      : <>
                        <th>
                          {orderHeadings.rangeNote}
                        </th>
                        <th>
                          {orderHeadings.outlay}
                        </th>
                        <th>
                          {orderHeadings.o}
                        </th>
                      </>
                      }
                        <th>
                          {orderHeadings.circleAmt}
                        </th>
                      {showSlimShopList
                      ? <th>
                          {orderHeadings.detailsLink}
                        </th>
                      : <>
                        <th>
                          {orderHeadings.circleMoney}
                        </th>
                        <th>
                          {null}
                        </th>
                      </>
                      }
                      </tr>
                    </thead>
                    <tbody>
                      {ordersList.flat(1)}
                    </tbody>
                    </Table>
                    {
                      ordersList.length > Constants.SMALL_NUM_OF_OIS  // 5
                        ? <HeadingBuilder
                            Size           = 'h5'
                            headingText    = {t('ordersList.button_text.addItemToShoppingList')}
                            // Put a Sku on the Trip's Shopping List
                            buttonAction   = {setShowShoppingListToFalse}
                            goButtonText   = {Constants.GET_ICON_RT_ARROW}
                            tippyText      = {Constants.DOT}
              tippyAlertText = {t('ordersList.button_text.tippyContentAddItem')}
                            // Click HERE to put a Sku from your Maybe-List onto the Shopping List...
                          />
                        : null
                    }
                   </>
                  : <p>{t('ordersList.pageText.noOrderItemsDefined')}</p>
                       // No Skus chosen yet for this Trip
              }
          </article>
        )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
  },
  [ ordersOfTheTrip, tmpShopAmtOfSku, tmpCircAmtOfSku, tmpOthersAmtOfSku,
    showOrderBreakout,
    shopper,
    if_shopper_is_circle_admin, showTripCost, trip, tripCosts, tripCostsWithTax,
    showTripBoughtCost,
    toggleShowOthersOrders, showOthersOrders, toggleShowOthersZeroOrders,
    showOthersZeroOrders,
    setShowShoppingListToFalse,
    showOutlayWithTax, toggleShowOutlayWithTax,
    textAlignLeft, textAlignCenter, dataForDownload,
    curr_symbol,
    shopListIdHeading,
    shopListBrandHeading,
    shopListNameLabelHeading,
    shopListStoreHeading,
    shopListWhoHeading,
    shopListUnitCountHeading,
    shopListPriceHeading,
    shopListUnitQtyHeading,
    shopListUnitCostHeading,
    shopListWantdHeading,
    shopListRangeNoteHeading,
    shopListOutlayHeading,
    shopListOColHeading,
    shopListCircleAmtHeading,
    shopListCircleMoneyHeading,
    shopListDetailsHeading,

    getActualWeight,
    orderItems,
    s_by_updated_at,
    shoppers_order_for_this_sku_this_trip,

    getIdColTippyText,
    getNameColComment,
    getCatHeader,
    getUnitCountColHeaderTippyContent,
    getUnitCountColHeaderAudioTippyContent,
    tripSkus,
    skusDimmedForThisTrip,
    skusBoughtForThisTrip,
    tripSkuWeights,
    getTswObject,
    isSkuBought,
    showIdentifier,
    showShortname,
    downloadIsClicked, 
    downloadInProgress,
    // skus,
    showSlimShopList, handleSlimShopCheckboxChange,
    showOiTableForSku,
    showGoShopList, showUnitCost, signedIn, prices, getPrice, t
  ]
  // TODO: 221206 does 't' really have to be in the dependency array?
  // https://bobbyhadz.com/blog/react-hook-useeffect-has-missing-dependency
  );
}

export default ShoppingList;
